import React, { useContext } from 'react'
import { DeleteVehicleContext, DeleteVehicleContextComp } from '../RemoveVehicleContext/DeleteVehicleContext'
import VehicleNote from '../1_Vehicle/VehicleNote/VehicleNote'
import ValidationModal from 'components/ValidationModal'
import { RemoveVehicleContext } from '../RemoveVehicleContext/RemoveVehicleContext'
import RemovableVehicles from '../1_Vehicle/RemoveVehicleBody/1_RemovableVehicles/RemovableVehicles'
import RemoveVehicleBtnNav from '../1_Vehicle/RemoveVehicleBtnNav/RemoveVehicleBtnNav'
import RequestedRemovalQuestions from '../1_Vehicle/RemoveVehicleBody/2_RequestedRemovalQuestions/RequestedRemovalQuestions'
import HelpfulDocumentsNJ from '../1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsNJ/HelpfulDocumentsNJ'
import VehicleDA from '../1_Vehicle/AddVehicleBody/6_DriverAssignment/VehicleDA_Main'
import HelpfulDocumentsPA from '../1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsPA/HelpfulDocumentsPA'

const RemoveVehicleMain = () => {
    const removeVehicleContext = useContext(RemoveVehicleContext)
    var removedVehicles = removeVehicleContext.removeVehicleClass.vehicles.vehiclesOnPolicy.removedVehicles

    return (
        <>
            <DeleteVehicleContextComp>
                <span className='px-md-5'>

                    {!(["VehicleDriverAssignment"].includes(removedVehicles[0]?.componentTracker)) &&
                        <>
                            <h5 className='text-primary text-center fw-bold mb-4'>REMOVE VEHICLE</h5>
                            <RemovableVehicles requestContext={RemoveVehicleContext} vehicleContext={DeleteVehicleContext} endorsementType={"RemoveVehicle"} />

                            {/* Display removal questions when vehicle selected */}
                            {removeVehicleContext?.removeVehicleClass?.vehicles?.vehiclesOnPolicy?.removedVehicles.length > 0 &&
                                <RequestedRemovalQuestions requestContext={RemoveVehicleContext} vehicleContext={DeleteVehicleContext} endorsementType={"RemoveVehicle"} />
                            }

                            {removeVehicleContext?.userData?.state == "New Jersey" &&
                                <>
                                    <hr />
                                    <div className='d-flex justify-content-center'>
                                        <HelpfulDocumentsNJ policyType={removeVehicleContext.userData.policyType} />
                                    </div>
                                </>
                            }
                            {removeVehicleContext?.userData?.state == "Pennsylvania" &&
                                <>
                                    <hr />
                                    <div className='d-flex justify-content-center'>
                                        <HelpfulDocumentsPA center='center' />
                                    </div>
                                </>
                            }
                        </>
                    }

                    {removedVehicles?.length > 0 && (["VehicleDriverAssignment"].includes(removedVehicles[0]?.componentTracker)) &&
                        <VehicleDA requestContext={RemoveVehicleContext} vehicleContext={DeleteVehicleContext} endorsementType={"RemoveVehicle"} />
                    }
                    <hr />
                    <VehicleNote />
                </span>
                <hr />
                <RemoveVehicleBtnNav />
            </DeleteVehicleContextComp>

            <ValidationModal
                title={removeVehicleContext.validationTitle}
                show={removeVehicleContext.showModal}
                handleClose={() => removeVehicleContext.setShowModal(false)}
                validationMsg={removeVehicleContext.validationMsg}
            />
        </>
    )
}

export default RemoveVehicleMain